import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterLink } from '@angular/router';
import { TranslatePipe, _ } from '@ngx-translate/core';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { EidsService, EidsStatus } from 'src/app/services/eids.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
    selector: 'app-profile-tab-eids',
    templateUrl: './profile-tab-eids.component.html',
    styleUrls: ['./profile-tab-eids.component.scss'],
    imports: [CommonModule, ReactiveFormsModule, TranslatePipe, LoaderComponent, RouterLink],
})
export class ProfileTabEidsComponent implements OnInit {
    loading = true;
    status: EidsStatus | null = null;
    requesting = false;
    verifying = false;
    codeForm = new FormGroup({
        code: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.pattern(/^\d{6}$/)] }),
    });

    constructor(
        private readonly eidsService: EidsService,
        private readonly toastService: ToastService,
    ) {}

    ngOnInit(): void {
        this.reload();
    }

    reload(): void {
        this.loading = true;
        this.eidsService.status().subscribe({
            next: (status) => {
                this.status = status;
                this.loading = false;
            },
            error: (err) => {
                this.loading = false;
                this.toastService.error(this.backendMessage(err, _('eids.error.generic')));
            },
        });
    }

    requestOtp(): void {
        if (this.requesting || !this.status?.profilePhonePresent) {
            return;
        }
        this.requesting = true;
        this.eidsService.requestOtp().subscribe({
            next: (result) => {
                this.requesting = false;
                this.toastService.success(_('eids.otp.sent'));
                if (result.devCode) {
                    this.codeForm.controls.code.setValue(result.devCode);
                }
            },
            error: (err) => {
                this.requesting = false;
                this.toastService.error(this.backendMessage(err, _('eids.otp.failed')));
            },
        });
    }

    verifyOtp(): void {
        if (this.codeForm.invalid || this.verifying) {
            this.codeForm.markAllAsTouched();
            return;
        }
        this.verifying = true;
        this.eidsService.verifyOtp(this.codeForm.controls.code.value).subscribe({
            next: () => {
                this.verifying = false;
                this.toastService.success(_('eids.otp.verified'));
                this.reload();
            },
            error: (err) => {
                this.verifying = false;
                this.toastService.error(this.backendMessage(err, _('eids.otp.failed')));
            },
        });
    }

    startSso(): void {
        const url = this.status?.ssoUrl;
        if (!url) {
            this.toastService.error(_('eids.sso.unavailable'));
            return;
        }
        window.location.href = url;
    }

    private backendMessage(err: { error?: { error?: string } }, fallback: string): string {
        const message = err?.error?.error;
        return typeof message === 'string' && message ? message : fallback;
    }
}
